// Per-community theme color cache, keyed by the community token. Full-screen
// loaders read this so they can render in the community's brand color *before*
// that community's data has finished loading — otherwise the very first paint
// falls back to a generic default. Any view that fetches community data writes
// the color here so every later loader (feed, landing, group collection) is
// already warm.
const themeKey = (token) => `cm_theme_${token}`;

// The cached brand color for a community, or null when nothing is stored yet.
export function readTheme(token) {
  try {
    return (token && localStorage.getItem(themeKey(token))) || null;
  } catch {
    return null;
  }
}
// Persist a community's brand color for future loaders. No-ops on empty input.
export function writeTheme(token, color) {
  try {
    if (token && color) localStorage.setItem(themeKey(token), color);
  } catch {
    /* ignore */
  }
}

